var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-status-toggler",on:{"click":_vm.toggle}},[_vm._t("default",null,{"flag":_vm.flag})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }